// extracted by mini-css-extract-plugin
module.exports = {"tekstBlokk":"dh-sk-tekstBlokk","overskrift":"dh-sk-overskrift","app--light":"dh-sk-app--light","app--dark":"dh-sk-app--dark"};